/* Boxari — les liens vers le bloc d'achat défilent en douceur jusqu'à #bx-buy sans recharger la page.
   Pris en charge : boutons [data-bx-scroll] des sections bx-*, et tout lien dont l'adresse finit par #bx-buy
   (les boutons natifs du thème, dont le champ url n'accepte pas une ancre seule). */
(function () {
  if (window.__bxScrollBound) return;
  window.__bxScrollBound = true;
  function findTarget() {
    return document.getElementById('bx-buy') ||
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('[id^="MainContent"]');
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (!a.hasAttribute('data-bx-scroll') && !/#bx-buy$/.test(href)) return;
    var target = findTarget();
    if (!target) return;
    e.preventDefault();
    var y = target.getBoundingClientRect().top + window.pageYOffset - 80;
    window.scrollTo({ top: Math.max(y, 0), behavior: 'smooth' });
  });
})();
